import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from '../../common/DialogModal';
import InputComponent from '../../common/InputComponent'
import Button from '../../Parts/Button'

import { validateAddressSendLetter } from '../../../utils/validator';

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  contentContainer: {
    padding: '25px',
    margin: 0,
    textAlign: 'left',
  },

  container: {
    width: '100%',
  },

  desc: {
    fontSize: '13px',
    padding: '20px',
    background: '#1A65FF0D',
  },

  buttonContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-evenly',
    margin: '40px 0',
  },

  row: {
    display: 'flex'
  }
});

class EditRecipientDialog extends React.Component {
  state = {
    post_code: '',
    address: '',
    company_name: '',
    branch: '',
    honorific: '',
    name: '',
    suffix: '',
    saveBtnPressed: false,
    error: {},
  }

  componentWillMount() {
    if (this.props.to) {
      this.setState({ ...this.props.to })
    }
  }

  handleChange = property => e => {

    if (this.state.saveBtnPressed) {
      let err = validateAddressSendLetter(this.state);

      this.setState({
        error: err
      })
    }

    this.setState({
      [property]: e.target.value,
    })
  }

  handleSave = () => {
    const { post_code, address, branch, honorific, name, company_name, suffix } = this.state;

    if (!this.state.saveBtnPressed) {
      this.validateForm();
    }

    this.setState({
      saveBtnPressed: true,
    }, () => {
      if (this.countErrors() === 0) {
        this.props.save({
          post_code,
          address,
          company_name,
          branch,
          honorific,
          name,
          suffix,
        });

        this.props.toggleDialog();
      }
    })
  }

  validateForm = () => {
    this.setState({ error: validateAddressSendLetter(this.state) });
  };

  countErrors = () => {
    return Object.keys(this.state.error).length;
  }

  render() {
    const { classes, toggleDialog, isOpen } = this.props;
    const { error } = this.state;

    return (
      <DialogModal
        title="宛名表記を編集"
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        <div className={classes.container}>
          <div className={classes.desc}>役職を略称に変更するなど、宛名用に表記を変更できます。キーマンデータベースのデータには一切影響ありません。</div>
        </div>

        <InputComponent
          title="郵便番号"
          placeholder="郵便番号を入力"
          key="post_code"
          value={this.state.post_code}
          onChange={this.handleChange('post_code')}
          error={error['post_code'] ? error['post_code'] : ''}
        />

        <InputComponent
          title="住所"
          placeholder="住所を入力"
          key="address"
          value={this.state.address}
          onChange={this.handleChange('address')}
          error={error['address'] ? error['address'] : ''}
        />

        <InputComponent
          title="会社名"
          placeholder="会社名を入力"
          key="company_name"
          value={this.state.company_name}
          onChange={this.handleChange('company_name')}
          error={error['company_name'] ? error['company_name'] : ''}
        />

        <InputComponent
          title="部署"
          placeholder="部署を入力"
          key="branch"
          value={this.state.branch}
          onChange={this.handleChange('branch')}
          error={error['branch'] ? error['branch'] : ''}
        />


        <InputComponent
          title="役職"
          placeholder="役職を入力"
          key="honorific"
          value={this.state.honorific}
          onChange={this.handleChange('honorific')}
          error={error['honorific'] ? error['honorific'] : ''}
        />

        <div className={classes.row}>
          <InputComponent
            title="氏名"
            placeholder="氏名を入力"
            key="name"
            value={this.state.name}
            onChange={this.handleChange('name')}
            error={error['name'] ? error['name'] : ''}
          />

          <div style={{ minWidth: '15px' }}></div>

          <InputComponent
            title="敬称"
            placeholder="敬称を入力"
            key="suffix"
            value={this.state.suffix}
            onChange={this.handleChange('suffix')}
            error={error['suffix'] ? error['suffix'] : ''}
          />
        </div>

        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={toggleDialog}
            size="large"
            text="キャンセル"
            type="ghost">
          </Button>

          <Button
            handleClickButton={this.handleSave}
            size="large"
            disabled={this.countErrors() !== 0}
            text="保存"
          >
          </Button>
        </div>
      </DialogModal>
    );
  }
}

EditRecipientDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  to: PropTypes.object,
  save: PropTypes.func.isRequired,
};

export default withStyles(styles)(EditRecipientDialog);



// WEBPACK FOOTER //
// ./src/components/SendLetter/dialogs/EditRecipientDialog.jsx